<template>
    <div class="widgetContainer">
        <div class="d-flex flex-column">
          <span class="widgetTitle">{{ $t("Webportal.Kpi") }}</span>
          <div id="kpiContainer" v-if="widgetdata && widgetdata.length > 0" class="d-flex flex-row h-100">
            <div v-for="(kpi, index) in widgetdata" :key="`${kpi.GroupCode}_${kpi.Code}`" class="kpi d-flex flex-column align-self-center mr-2">
              <span :id="`kpiName_${index}`" class="kpiName widgetText text-center text-truncate">{{ kpi.Name }}</span>
              <div class="d-flex flex-row align-self-center text-nowrap">
                <div class="thresholdIndicator" :style="{ 'background-color': getThresholdColor(thresholds, kpi.Result, '#fff', kpi) }" />
                <div class="font-weight-bold mr-1">{{ $n(kpi.Result, { minimumFractionDigits: percentageNumberOfDecimalPoints, maximumFractionDigits: percentageNumberOfDecimalPoints}) }}%</div>
                <div class="font-weight-light">(N = {{ kpi.HasResultCount }})</div>
              </div>

              <b-tooltip no-fade :delay="toolTipDelay.delay" :target="`kpiName_${index}`">
                <strong>{{ kpi.Name }}</strong>
                <p class="m-0" v-for="survey in kpi.Surveys" :key="survey.SurveyId">
                  {{ survey.SurveyTitle }}
                </p>
              </b-tooltip>
            </div>
          </div>
          <div id="emptyContainer" class="h-100 text-center" v-else>
            <font-awesome-icon class="mt-3 text-muted" :icon="['far', 'empty-set']" size="lg" />
          </div>
        </div>
        <div class="align-self-end">
          <button class="closeButton" v-on:click="$emit('close-widget')">
              <font-awesome-icon class="closeButtonIcon" icon="window-close" size="xs"/>
          </button>
        </div>
    </div>
</template>

<script>
  import AppConfig from '@/mixins/AppConfig';
  import ThresholdColor from '@/mixins/ThresholdColor-APP_TARGET';

  export default {
    name: "WidgetKpi",

    mixins: [ AppConfig, ThresholdColor ],

    props: {
      widgetdata: { type: Array, default: null },
      thresholds: null,
      percentageNumberOfDecimalPoints: { type: Number, default: 2 }
    }
  }
</script>

<style lang="scss" scoped>
  #emptyContainer {
    min-width: 60px;
  }

  #kpiContainer {
    font-size: 14px;

    .kpi {
      border-top: 1px black solid;
      border-bottom: 1px black solid;
    }

    .kpiName {
      max-width: 150px;
    }

    .thresholdIndicator {
      margin-top: 3px;
      margin-right: 3px;
      width: 15px;
      height: 15px;
    }
  }
</style>